import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class DadosSocService extends CRUDService {
    constructor() {
        super("dadosSoc");
    }

    consultar(params){
        return http.post("/dadosSoc", params)
    }
}